import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { EditIconPencil } from '../../../Assets/icons';
import { opdFeeSchema } from '../../../Schema';
import { setDoctorOpdFee } from '../../../Store/authSlice';
import Button from '../../UI/Button';
import { Input } from '../../UI/Input';
import CommonCard from '../CommonCard';
import classes from './OpdFee.module.css';
const initialValues = {
  opdFee: ''
};
const OpdFeeSection = ({ onSubmit, allServices, className, show, loading, showButton = true }) => {
  const dispatch = useDispatch();
  const services = useSelector((state) => state?.serviceReducer?.services);
  const [editFeeDisable, setEditFeeDisable] = useState(true);
  const [formattedOpdFee, setFormattedOpdFee] = useState('');
  const formik = useFormik({
    initialValues,
    validationSchema: opdFeeSchema,
    onSubmit: (values, { resetForm }) => {
      if (typeof onSubmit === 'function')
        onSubmit({ feeAmount: values?.opdFee }, () => {
          resetForm();
          setEditFeeDisable(true);
          dispatch(setDoctorOpdFee(values?.opdFee));
          setFormattedOpdFee(services?.find((ele) => ele?.serviceId === null)?.serviceName);
        });
    }
  });
  const {
    touched,
    errors,
    values,
    handleSubmit,
    setValues,
    resetForm,
    setFieldValue,
    setFieldTouched
  } = formik;
  const handleChangeWithTouch = (field, value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };
  const handleChangeOpdFee = (value) => {
    const rawValue = String(value).replace(/,/g, '');
    const formattedValue = Number(rawValue).toLocaleString()
      ? Number(rawValue).toLocaleString()
      : '';
    handleChangeWithTouch('opdFee', rawValue);
    setFormattedOpdFee(formattedValue);
  };
  useEffect(() => {
    if (!show) {
      resetForm();
    }
    if (Array.isArray(allServices)) {
      handleChangeOpdFee(allServices?.find((ele) => ele?.serviceId === null)?.serviceFees);
    }
  }, [show, allServices]);
  return (
    <form onSubmit={handleSubmit}>
      {/* <section className={classes.opdFeeWrapper}> */}
      <Row className={classes.wrapper}>
        {/* <div className={classes.opdName}> */}
        <Col sm={showButton ? 5 : 6} className="pe-0">
          <Input label={'Type'} placeholder="Type" value={'OPD'} disabled={true} />
          {/* </div> */}
        </Col>
        {/* <div className={classes.opdFees}> */}
        <Col
          lg={showButton ? 5 : 6}
          xl={6}
          md={showButton ? 5 : 6}
          xs={showButton ? 10 : 6}
          className="pe-0">
          <Input
            regexType="format"
            label={'Fee'}
            customStyle={{ gap: 0 }}
            inputStyle={{ paddingLeft: '4px' }}
            placeholder="Enter Fee"
            disabled={editFeeDisable}
            leftIcon={<span className={classes.rs}>Rs. </span>}
            value={formattedOpdFee || values.opdFee}
            errorText={touched?.opdFee && errors?.opdF}
            setter={(e) => {
              handleChangeOpdFee(e);
            }}
          />
        </Col>
        {/* </div> */}
        {showButton && (
          <Col
            xs={showButton ? 2 : 6}
            xl={showButton ? 1 : 6}
            style={{ display: 'flex' }}
            className="pe-0">
            <CommonCard
              style={{ alignSelf: 'end' }}
              className={classes.quickAction}
              type="button"
              Tag="button"
              onClick={() => {
                setEditFeeDisable((current) => !current);
              }}>
              <EditIconPencil />
            </CommonCard>
          </Col>
        )}
      </Row>
      {/* </section> */}
      <div className={classes.errorWrapper}>
        <p className={'errorText'}>{}</p>
        <p className={'errorText'}>{touched?.opdFee && errors?.opdFee}</p>
      </div>
      {!editFeeDisable && (
        <div className={classes.ctaOpdFeeWrapper}>
          <Button disabled={loading} label={'Save'} variants="view" type="submit" />
        </div>
      )}
    </form>
  );
};

export default OpdFeeSection;
